import { themeInitialState } from "./utils";
import {
  FETCH_THEME_DATA,
  FETCH_THEME_DATA_FAILURE,
  FETCH_THEME_DATA_SUCESS,
  GET_ALL_THEME_DATA,
  GET_ALL_THEME_DATA_FAILURE,
  GET_ALL_THEME_DATA_SUCCESS,
  SET_THEME_DATA,
  UPDATE_THEME_DATA,
  RESET_THEME_DATA,
  UPDATE_THEME_DATA_SUCCESS,
  UPDATE_THEME_DATA_FAILURE,
  FETCH_ACTIVE_THEME_ID,
  UPDATE_THEME_ERROR,
  UPDATE_FETCH_THEME_LOADER,
} from "./constants";
import { IThemeInitalState } from "./interface";

export interface IinitialState {
  form: IThemeInitalState;
  themeList: IThemeInitalState[];
  isThemeEdited: boolean;
  loaders: {
    form: boolean;
    all: boolean;
    isThemeSaving: boolean;
  };
  error: {
    form: string;
    name: string;
    description: string;
  };
}

export const initialState = (): IinitialState => {
  return {
    form: { ...themeInitialState() },
    themeList: [],
    isThemeEdited: false,
    loaders: {
      form: false,
      all: false,
      isThemeSaving: false,
    },
    error: {
      form: "",
      name: "",
      description: "",
    },
  };
};

export const themeReducer = (
  state = initialState(),
  action: {
    type: string;
    payload: any;
  }
) => {
  const newState = { ...state };
  switch (action.type) {
    case UPDATE_THEME_DATA:
      let newStateForm = {
        ...newState,
      };
      const payload = action.payload;
      if (payload.base) {
        newStateForm[payload.base] = {
          ...payload.data,
        };
        newState.isThemeEdited = true;
      } else {
        newStateForm = {
          ...newStateForm,
          form: {
            ...newStateForm.form,
            ...action.payload.form,
          },
          isThemeEdited: action.payload.isThemeEdited ?? false,
        };
      }
      return newStateForm;
    case UPDATE_THEME_ERROR: {
      const error = { ...newState.error, ...action.payload };
      return {
        ...newState,
        error,
      };
    }
    case SET_THEME_DATA:
      newState.loaders = {
        ...newState.loaders,
        form: false,
      };
      newState.form = {
        ...newState.form,
        // ...action.payload,
      };
      return newState;
    case UPDATE_FETCH_THEME_LOADER:
      newState.loaders = {
        ...newState.loaders,
        form: true,
      };
      return newState;
    case FETCH_THEME_DATA_SUCESS:
      newState.loaders = {
        ...newState.loaders,
        form: false,
      };
      return newState;
    case FETCH_THEME_DATA_FAILURE:
      newState.loaders = {
        ...newState.loaders,
        form: false,
      };
      newState.error = {
        ...newState.error,
        // form: action.payload,
      };
      return newState;
    case GET_ALL_THEME_DATA: {
      const loaders = { ...newState.loaders };
      loaders.all = true;
      return {
        ...newState,
        loaders,
      };
    }
    case GET_ALL_THEME_DATA_SUCCESS: {
      newState.themeList = action.payload;
      const loaders = { ...newState.loaders };
      loaders.all = false;
      return {
        ...newState,
        loaders,
      };
    }
    case GET_ALL_THEME_DATA_FAILURE: {
      const loaders = { ...newState.loaders };
      loaders.all = false;
      return {
        ...newState,
        loaders,
      };
    }
    case UPDATE_THEME_DATA_SUCCESS: {
      const payload = action.payload as IThemeInitalState;
      const loaders = { ...newState.loaders };
      loaders.form = false;

      return {
        ...newState,
        loaders,
        ...(payload ? { form: payload } : {}),
      };
    }
    case UPDATE_THEME_DATA_FAILURE: {
      const loaders = { ...newState.loaders };
      loaders.form = false;
      return {
        ...newState,
        loaders,
      };
    }
    case RESET_THEME_DATA: {
      return {
        ...newState,
        form: { ...themeInitialState() },
        isThemeEdited: false,
      };
    }
    default:
      return newState;
  }
};
